import { render, staticRenderFns } from "./OpenOpportunitiesByOwnerTable.vue?vue&type=template&id=c6146d2e&scoped=true"
import script from "./OpenOpportunitiesByOwnerTable.vue?vue&type=script&lang=js"
export * from "./OpenOpportunitiesByOwnerTable.vue?vue&type=script&lang=js"
import style0 from "./OpenOpportunitiesByOwnerTable.vue?vue&type=style&index=0&id=c6146d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6146d2e",
  null
  
)

export default component.exports